import React from 'react';
import Footer from './Footer';
import '../styles/global.scss';
import { Helmet } from 'react-helmet';
import { withPrefix } from 'gatsby';

export default function Layout({ pageTitle, children }) {
  return (
    <>
      <Helmet>
        <script src={withPrefix('global.js')} type="text/javascript" />
      </Helmet>
      <div className="site">
          <title>{pageTitle + " | Verve Kombucha"}</title>
          <main className="main" id="main">
              { children }
          </main>
          <Footer />
      </div>
      <script></script>
    </>
  )
}
